export class ManageCRRAModel{
    userid: number;
    title: string;
    description: string = '';
}